<!-- <div class="">
   <div class="row mb-4">
    <div class="col-md-8">
      <h4>weekly trend chart for registered cases</h4>
    </div>
  </div>
</div> -->
<div [id]="chartdiv_id" class="lineChartDiv"></div>
